export const EmploymentStatusOptions = [
  { label: '', value: '' },
  { label: 'Full Time', value: 'fulltime' },
  { label: 'Self Employed', value: 'selfemployed' },
  { label: 'Part Time', value: 'parttime' },
  { label: 'Not Employed', value: 'unemployed' }
]

export const PreviousOccupation = [
  { label: '', value: '' },
  { label: 'Homemaker', value: 'homemaker' },
  { label: 'Retiree', value: 'retiree' },
  { label: 'Student', value: 'student' },
  { label: 'Unemployed', value: 'unemployed' },
  { label: 'Others', value: 'others' }
]
